import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

import PATHS from "../paths";
import dashboardPathByRole from "../dashboardPathByRole";

import useUserStore from "@/features/auth/store/useUserStore";
import useUserState from "@/hooks/useUserState.tsx";
import AppLoader from "@/components/AppLoader";

const RedirectRoute = () => {
  const user = useUserStore((state) => state.user);
  const userState = useUserState();
  const redirect = useNavigate();

  useEffect(() => {
    if (!user) return redirect(PATHS.SIGN_IN);

    const { isOnboarded, role } = user;

    if (!isOnboarded) return redirect(PATHS.SIGN_UP);

    switch (userState) {
      case "tutorWithoutProfile":
      case "tutorWithoutPricing":
      case "tutorWithoutPayments":
      case "tutorWithoutWorkspace":
        redirect(PATHS.TUTOR.ONBOARDING.INDEX);
        break;
      default:
        redirect(dashboardPathByRole[role]);
    }
  }, []);

  return <AppLoader />;
};

export default RedirectRoute;
